import React, { Fragment, useEffect, useState, useRef, useSelector } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
  FormGroup,
  Form
} from "reactstrap";
import { fetchCommissionCalculation, processCommission, verifyInvoiceOtp, checkCommissionInvoice, sendOtpForInvoiceVerification, verifyInvoiceOtpNormalWallet, sendInvoiceLink } from "../../../api"; // Ensure API calls are correctly defined
import GetLoader from "../../common/getLoader";
import { getFromLocalStorage } from "../../../hooks/useLocalStorage";
import convertToRupees from "../../../utilities/convertToRupees";
import { toast } from "react-toastify";
import OtpInput from 'react-otp-input';
import { useForm } from "react-hook-form";
import FileUploadComponent from "../../common/FileUpload";
import { USE_V2_WEBSOCKET } from "../../../constant";
import usePaymentWebSocket from '../../../hooks/usePaymentWebSocket';
import { getInvoiceDocumentByRole } from '../../../api';



const PayInvoiceNormalWallet = ({ isOpen, toggle, selectedDocumentIds,selectedInvoiceIds, offlinePayment }) => {
  const [calculation, setCalculation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [documentCommissionDetails, setDocComDetails] = useState([]);
  const [wantInvoice, setWantInvoice] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [mobileNoModalOpen, setMobileNoModalOpen] = useState(false);
  // const { data } = useSelector((state) => state.login);
  const [state, setState] = useState({ otp: '', mobileNumber: "" });
  const [invoiceNumber, setInvoiceNo] = useState("");
  const [txnid, setTxnid] = useState(null); // Used for dynamic WebSocket connection
  const componentRef = useRef();
  const hasToggledRef = useRef(false);
  const { register, setValue, trigger, getValues } = useForm();

  // Connect WebSocket dynamically when txnid is available
  const { paymentEvent, clearEvent } = usePaymentWebSocket(txnid, USE_V2_WEBSOCKET && !!txnid);

  useEffect(() => {
    if (paymentEvent) {
      if (paymentEvent.status === 'SUCCESS' || paymentEvent.status?.toLowerCase() === 'completed') {
        setProcessing(false);
        setRedirecting(false);
        if (!hasToggledRef.current) {
          hasToggledRef.current = true;
          toggle(); // Close modal
        }
        
        window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'SUCCESS',
            message: 'Payment completed successfully!',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Paid (INR):'
          }
        }));
        
        window.dispatchEvent(new Event('refresh-invoices')); // Instruct parent to refresh
      } else if (paymentEvent.status === 'FAILED' || paymentEvent.status?.toLowerCase() === 'failed') {
        setProcessing(false);
        setRedirecting(false);
        if (!hasToggledRef.current) {
          hasToggledRef.current = true;
          toggle(); // Close modal
        }
        
        window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
          detail: {
            status: 'FAILED',
            message: 'Payment failed! Please try again.',
            documentInfo: paymentEvent.payload?.amount || calculation?.net_payable_amount || 0,
            documentLabel: 'Amount Attempted (INR):'
          }
        }));
      }
      clearEvent();
    }
  }, [paymentEvent, toggle, clearEvent]);

  // ✅ Get Partnership ID from Local Storage
  const user = getFromLocalStorage("user");
  const role_id = getFromLocalStorage("ROLE")?.role_id;
  const partnership_id = user?.partnership_id || user.partnerInfo?.partnership_id || null;
  // const businessPartnerInfo = user.partnerInfo;
  // const isGSTReg = user?.partnerInfo.user.is_gst_registered || false;
  // ✅ Convert selectedDocumentIds object to an array
  const documentIdsArray = Object.keys(selectedDocumentIds).map(Number);
  console.log(documentIdsArray, "Selected Document IDs");

  // Polling fallback to ensure we catch success even if WS drops the message (e.g. UAT load balancer)
  useEffect(() => {
    console.log(`[POLLING DEPENDENCIES] processing: ${processing}, redirecting: ${redirecting}, txnid: ${txnid}`);
    
    let intervalId;
    if (processing && redirecting && txnid) {
      intervalId = setInterval(async () => {
        try {
          // Fetch the latest status for these documents (fetching up to 5000 to ensure we find older invoices)
          const response = await getInvoiceDocumentByRole(role_id, 1, 5000, "", [], []);
          
          const documentList = response?.data?.result?.documentDetails;
          console.log("[POLLING] documentList:", documentList);
          
          if (documentList) {
            console.log("[POLLING] documentIdsArray:", documentIdsArray);
            // Check if all selected invoices are PAID / PENDING_FOR_COMMISSION
            const allPaid = documentIdsArray.every(id => {
              const doc = documentList.find(d => Number(d.document_id) === Number(id));
              console.log(`[POLLING] checking doc id: ${id}`, doc);
              
              if (!doc) {
                console.log(`[POLLING] doc ${id} not found in pending list, assuming SUCCESS/PENDING_FOR_COMMISSION`);
                return true;
              }
              
              const status = doc.claim_status?.toUpperCase();
              console.log(`[POLLING] doc ${id} status: ${status}`);
              return (status === "PENDING_FOR_COMMISSION" || status === "PAID" || status === "SUCCESS");
            });

            console.log("[POLLING] allPaid evaluates to:", allPaid);
            if (allPaid) {
              console.log("Polling detected payment success!");
              setProcessing(false);
              setRedirecting(false);
              setTxnid(null);
              if (!hasToggledRef.current) {
                hasToggledRef.current = true;
                toggle(); // Close modal
              }
              
              window.dispatchEvent(new CustomEvent('show-global-payment-modal', {
                detail: {
                  status: 'SUCCESS',
                  message: 'Your wallet was successfully recharged!',
                  documentInfo: calculation?.net_payable_amount || 0,
                  documentLabel: 'Amount Recharged (INR):'
                }
              }));
              
              window.dispatchEvent(new Event('refresh-invoices'));
              clearInterval(intervalId);
            }
          }
        } catch (e) {
          console.error("Polling check failed", e);
        }
      }, 5000); // Poll every 5 seconds
    }
    
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [processing, redirecting, txnid, documentIdsArray, role_id, calculation, toggle]);

  const toggleTermsModal = () => setTermsModalOpen(!termsModalOpen);
  const toggleOtpModal = () => setOtpModalOpen(!otpModalOpen);
  const toggleMobileNoModal = () => setMobileNoModalOpen(!mobileNoModalOpen);
  const handleMobileNumberChange = (mobileNumber) => setState({ ...state, mobileNumber })

  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [confirmDetails, setConfirmDetails] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setEmail(user?.email || "");
    setMobileNumber(user?.phone_no || "");
  }, []);

  const handleAgreeClick = () => {
    setTermsAccepted(true);
    toggleTermsModal();
  };


  const handleChange = (otp) => setState({ otp });
  const handleInvoiceNumberChange = (invoiceNumber) => setInvoiceNo(invoiceNumber)

  // const setOtpResquest = () => { 
  //     submitNumberToGetOtp()
  // }

  // const submitNumberToGetOtp = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await sendOtpForInvoiceVerification({
  //       mobileNumber: state.mobileNumber,
  //     })

  //     if (response?.data.code === 200) {
  //       toast.success(response?.data.msg);
  //       toggleOtpModal();
  //     }

  //     if (response?.data.code === 400) {
  //       toast.error(response?.data.error);
  //     }

  //   } catch (error) {
  //     const errorMsg =
  //       error.response?.data?.error || "An error occurred while fetching data.";
  //     toast.error(errorMsg);
  //   }
  //   setLoading(false);
  // }

  // ✅ Fetch commission calculation from backend
  const fetchCalculation = async () => {

    if (!partnership_id || documentIdsArray.length === 0) return;
    setLoading(true);
    setErrorMessage("");
    setCalculation(null);

    try {
      const response = await fetchCommissionCalculation({
        document_ids: documentIdsArray,
        partnership_id,
        role_id: role_id
      });

      if (response?.data?.result) {
        setCalculation(response.data.result);
        setDocComDetails(response.data.result.documentTxnList)

      } else {
        throw new Error("Invalid response from server.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
    }
    setLoading(false);
  };

  // ✅ Fetch data when modal opens
  useEffect(() => {
    // if(documentIdsArray.length < 31){
    console.log("IsOpen:", isOpen);
    if (isOpen) {
      fetchCalculation();
      setActiveStep(0);
    }
    // }else{
    //   isOpen = false;
    //   toast.error(`You can't make payment of more than 30 documents at a time. Seleted documents count is ${documentIdsArray.length}`)
    // }

  }, [isOpen]);



  const handleProceedToPay = async () => {
    console.log("Calculation before proceeding to pay:", calculation);
    if (!calculation) return;

    setProcessing(true);
    // toast.info("Processing commission, please wait...");

    try {
      console.log("VIEW PAYLOAD++++++++++++", {
        // otp: state.otp,
        document_ids: documentIdsArray,
        partnership_id,
      });
      const response = await verifyInvoiceOtpNormalWallet({
        // otp: state.otp,
        document_ids: documentIdsArray,
        partnership_id,
        partner_invoice_number: invoiceNumber,
        mobileNumber: state.mobileNumber
      });



      if (response?.data?.result.paymentResponse?.payuUrl && response?.data?.result?.paymentResponse?.payUPayload) {
        const payuUrl = response.data.result.paymentResponse.payuUrl;
        const payuPayload = response.data.result.paymentResponse.payUPayload;
        if (payuPayload?.txnid) setTxnid(payuPayload.txnid);

        toast.success("Redirecting to payment gateway...");
        setRedirecting(true);

        // Create a dynamic form for redirection with full payload
        const form = document.createElement("form");
        form.method = "POST";
        form.action = payuUrl;
        // Append all payload parameters as hidden inputs
        Object.entries(payuPayload).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit(); // Submit the form to PayU
      } else {
        throw new Error("Failed to process commission.");
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || "Failed to process commission.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
      setProcessing(false);
    }
  };

  const offlineNormalPay = async (file, remark) => {
    try {
      let payload = {
        document_ids: documentIdsArray,
        partnership_id,
        supportedFile: file,
        isOfflinePayment: true,
        remark: remark || "",
      };
      console.log("Payload for Offline Normal Payment:", payload);

      const response = await verifyInvoiceOtpNormalWallet({
        ...payload
      });

      console.log("Response of Offline Normal Payment:", response);
      if (response?.data?.result) {
        const ticketNumber = response.data.result.ticketNumber;
        toast.success(`Tikcet ${ticketNumber} has been created successfully`);
      } else {
        throw new Error("Invalid response from server.");
      }
      toggle()
    } catch (error) {
      console.log("Error in Offline Normal Payment:", error);
      const errorMsg =
        error.response?.data?.error || "An error occurred while fetching data.";
      setErrorMessage(errorMsg);
      toast.error(errorMsg);
      toggle()
    }

  }

   const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleOfflineSubmit = async () => {
    const formValues = getValues();
    if (!formValues.remark || formValues.remark.trim() === "") {
      toast.error("Please enter a remark before submitting.");
      return;
    }
    if (!formValues.file || (Array.isArray(formValues.file) && formValues.file.length === 0)) {
      toast.error("Please upload a file before submitting.");
      return;
    }
    console.log("Form Values:", formValues);
    await offlineNormalPay(formValues.file, formValues.remark);
  }

  const handleSendLink = async () => {
    try {
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Mobile validation (10 digits)
      const mobileRegex = /^[0-9]{10}$/;

      if (!email.trim()) {
        toast.error("Email is required");
        return;
      }

      if (!emailRegex.test(email.trim())) {
        toast.error("Please enter a valid email address");
        return;
      }

      if (!mobileNumber.trim()) {
        toast.error("Mobile number is required");
        return;
      }

      if (!mobileRegex.test(mobileNumber.trim())) {
        toast.error("Please enter a valid 10-digit mobile number");
        return;
      }

      const payload = {
        "reqEmail": email,
        "reqPhone": mobileNumber,
        "invoice_ids": selectedInvoiceIds,
        "role_id": role_id,
          "isNormalWallet": true
        };
        const response = await sendInvoiceLink(payload);
        // console.log(response, "sendLink response");
  
        // Close modal
        toggle();
  
        if(response?.data?.code === 200){
          toast.success("Payment link sent successfully");
        }
      } catch (error) {
        toast.error("Failed to send payment link");
      }
    };

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
        <div ref={componentRef} className="print_page m-15 p-0">


          {activeStep === 0 && (
            <>
              <ModalHeader toggle={toggle} className="pb-0 mb-0 border-0">
                {loading ? "Fetching Invoice Details..." : "Invoice Details"}
              </ModalHeader>
              <ModalBody>
                {loading ? (
                  <GetLoader />
                ) : errorMessage ? (
                  <div className="text-center text-danger">
                    <h5>{errorMessage}</h5>
                    <Button color="danger" onClick={toggle}>
                      Close
                    </Button>
                  </div>
                ) : (
                  <>

                    <Row>
                      <Col xl="12" md="12" className="pl-2 pr-2">
                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                          }}
                        >
                          <thead
                            style={{
                              background: "#f2f2f2",
                              fontSize: "14px",
                            }}
                          >
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {"Particulars"}
                              </th>
                              <th
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {"Amount (INR)"}
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ fontSize: "14px" }}>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                Total Documents
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {calculation?.total_documents || 0}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Cost`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.total_premium_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Commission`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.total_commission_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {`Total Amount`}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(
                                  calculation?.base_amount_payable || 0,
                                  true
                                )}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {"GST @ 18%"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(calculation?.gst_amount || 0)}
                              </td>
                            </tr>

                            {/* <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                              >
                                {"TDS @ 2%"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {convertToRupees(calculation?.tds_amount || 0)}
                              </td>
                            </tr> */}
                          </tbody>

                          <tfoot>
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "left",
                                }}
                                className="mb-1"
                              >
                                {"Amount Payable"}
                              </td>
                              <td
                                style={{
                                  border: "1px solid #ddd",
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                                className="mb-2"
                              >
                                {convertToRupees(
                                  calculation?.net_payable_amount || 0,
                                  true
                                )}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </Col>
                    </Row>
                    {!offlinePayment ?
                      (
                        <Row>
                          <Col className="text-center mt-3">
                            <Button
                              color="success"
                              size="md"
                              // onClick={handleProceedToPay}
                              onClick={handleNext}
                              disabled={processing || redirecting}
                            >
                              {processing ? "Processing..." : redirecting ? "Redirecting..." : "Send Link"}
                            </Button>
                            <Button
                             className="ml-2"
                              color="success"
                              size="md"
                              // onClick={handleProceedToPay}
                              onClick={handleProceedToPay}
                              disabled={processing || redirecting}
                            >
                              {processing ? "Processing..." : redirecting ? "Redirecting..." : "Proceed to Pay"}
                            </Button>
                          </Col>
                        </Row>
                      )
                      :
                      (
                        <Row>
                          <Col xl="8" md="8" className="mt-3">
                            <div style={{ width: 180, margin: "auto", textAlign: "center" }}>
                              <FormGroup>
                                <Label for="remark">
                                  Remark (<span style={{ color: "red" }}>* required</span>)
                                </Label>
                                <Input
                                  type="text"
                                  id="remark"
                                  name="remark"
                                  innerRef={register}
                                  placeholder="Enter Remark"
                                />
                              </FormGroup>
                              <FileUploadComponent
                                register={register}
                                name="file"
                                setValue={setValue}
                                trigger={trigger}
                                getValues={getValues}
                                data={""}
                                add={getValues()["file"]?.length > 0 ? false : true}
                              />
                              <div style={{ color: "red", marginTop: "5px", fontSize: "13px" }}>
                                * File is required
                              </div>
                            </div>
                          </Col>
                          <Col xl="4" md="4" className="text-right mt-3">
                            <Button
                              color="success"
                              size="md"
                              onClick={handleOfflineSubmit}
                            >
                              Proceed to Finance
                            </Button>
                          </Col>
                        </Row>
                      )}
                  </>
                )}
              </ModalBody>
            </>

          )}

          {activeStep === 1 && (
            <>
              <ModalHeader toggle={toggle}>
                Send Payment Link
              </ModalHeader>

              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="email">
                        Email Address <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </FormGroup>
                  </Col>

                  <Col md={12}>
                    <FormGroup>
                      <Label for="mobileNumber">
                        Mobile Number <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="tel"
                        id="mobileNumber"
                        name="mobileNumber"
                        placeholder="Enter Mobile Number"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        maxLength={10}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row className="mt-2">

                  <Col md={12}>

                    <FormGroup check>

                      <Label check>
                        <Input
                          type="checkbox"
                          checked={confirmDetails}
                          onChange={() => setConfirmDetails(!confirmDetails)}
                        />{" "}
                        I confirm that the above email address and mobile number are correct.
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>


                <Row className="mt-3">
                  <Col className="text-right">
                    <Button
                      color="secondary"
                      className="mr-2"
                      onClick={() => setActiveStep(1)}
                    >
                      Back
                    </Button>

                    <Button
                      color="success"
                      disabled={
                        !confirmDetails ||
                        !email.trim() ||
                        !mobileNumber.trim()
                      }
                      onClick={handleSendLink}
                    >
                      Send Link
                    </Button>
                  </Col>
                </Row>
              </ModalBody>
            </>
          )}

        </div>
      </Modal>

      {/* Terms and Conditions Modal */}
      {/* <Modal isOpen={termsModalOpen} toggle={toggleTermsModal} size="lg">
        <ModalHeader toggle={toggleTermsModal}>Terms and Conditions</ModalHeader>
        <ModalBody sx={{ maxHeight: '400px', overflowY: 'auto', scrollbarWidth: "none", msOverflowStyle: "none" }}>
          <p>I hereby agree that I am the Authorized Signatory of Proprietorship / Partnership Firm / Company/ LLP (hereinafter referred as "Entity") duly authorized to digitally sign the invoices, and receive One Time Password (OTP) on my registered mobile number for business purpose on behalf of the said Entity. I hereby provide my consent for the above and to receive OTP on the said number to authenticate details on behalf of the Entity. I understand and agree that the OTP provided herein;</p>

          <p>- shall be used only for the purpose of authenticating the identity of the Authorized Signatory on behalf of the said Entity through the Mobile based OTP system.,</p>
          <p>- shall be used to avail my consent for digitally signing the invoices (using my Digital Signature) specific under this Travel Care  / Paperless arrangement with Europ Assistance India Private Limited ("EAI") and not for any other purpose otherwise.</p>
          <p>I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it. I hereby authorize sharing of the information furnished herewith to be used for business purpose agreed herein.</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleTermsModal}>Close</Button>
          <Button color="primary" onClick={handleAgreeClick}>I Agree</Button>
        </ModalFooter>
      </Modal> */}

      {/* <Modal isOpen={otpModalOpen} toggle={toggleOtpModal} size="md">
        <ModalHeader toggle={toggleOtpModal}>OTP is shared to {businessPartnerInfo.phone_number}.</ModalHeader>
        <ModalBody style={{ maxHeight: '50%', overflowY: 'auto' }}>
          <Row>
            <Col xs="8">
              <FormGroup>
                <Label for="otp">Submit your OTP!</Label>
                <OtpInput
                  value={state.otp}
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span style={{ width: '12px' }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  inputStyle={{
                    border: '1px solid #CFD3DB ',
                    borderRadius: '9px',
                    width: '50px',
                    height: '50px',
                    fontSize: '16px',
                    fontWeight: '400',
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs="1">
              <Button
                color="primary"
                size="md"
                type="submit"
                onClick={handleProceedToPayViaOtp}
                disabled={loading ? loading : loading}
              >
                {processing ? "Processing..." : redirecting ? "Redirecting..." : "Submit"}

              </Button>
            </Col>
          </Row>

        </ModalBody>
      </Modal> */}

    </Fragment>
  );
};

export default PayInvoiceNormalWallet;
